<template>
  <div class="p-5 pt-1">
    <p class="font-semibold text-3xl">
      Detail Loading Plan
    </p>
    <div class="mt-6">
      <div class="bg-white rounded-2xl p-6 w-content text-base">
        <span class="font-semibold">End User</span>
        <span class="bg-primary text-white rounded-xl py-1 px-2 ml-3">
          {{ $route.params.endUser || vesselLineUpEndUser }}
        </span>
      </div>
    </div>
    <data-table
      class="mt-6"
      is-td-static
      :loading="isLoading"
      :table-header="tableHeaders"
      :table-data="tableData"
      :sort-by="sortBy"
      :sort-dir="sortDir"
      body-height="100vh"
      @sort="sort"
    >
      <template #td="{ row, header }">
        {{ putOutOrFormatNumber(header, row[header]) }}
      </template>
    </data-table>
    <div class="mt-16 flex items-center justify-end">
      <vs-button
        class="button shadow-secondary ml-6"
        color="secondary"
        @click="$router.push({ name: $route.meta.parent.name })"
      >
        Back
      </vs-button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import DataTable from '@/components/dataTable'
import { PAGE_TITLE } from '@/fixtures/Constants'
import { isNumber, sortData } from '@/utils/salesPlanUtils'

export default {
  metaInfo: {
    title: `${PAGE_TITLE} Detail Loading Plan`
  },
  components: {
    DataTable
  },
  data(){
    return {
      isLoading: false,
      isSubmitDisabled: false,
      sortBy: '',
      sortDir: null,
      tableHeaders: [
        { key: 'barge_ton_plan', label: 'Barge Ton (Plan)', sortable: true },
        { key: 'barge_ton_actual', label: 'Barge Ton (Actual)', sortable: true },
        { key: 'tm_plan', label: 'TM (Plan)', sortable: true },
        { key: 'tm_actual', label: 'TM (Actual)', sortable: true },
        { key: 'm_plan', label: 'M (Plan)', sortable: true },
        { key: 'm_actual', label: 'M (Actual)', sortable: true },
        { key: 'ash_plan', label: 'ASH (Plan)', sortable: true },
        { key: 'ash_actual', label: 'ASH (Actual)', sortable: true },
        { key: 'ts_plan', label: 'TS (Plan)', sortable: true },
        { key: 'ts_actual', label: 'TS (Actual)', sortable: true },
        { key: 'cv_adb_plan', label: 'CV ADB (Plan)', sortable: true },
        { key: 'cv_adb_actual', label: 'CV ADB (Actual)', sortable: true },
        { key: 'cv_ar_plan', label: 'CV AR (Plan)', sortable: true },
        { key: 'cv_ar_actual', label: 'CV AR (Actual)', sortable: true },
        { key: 'product', label: 'Product', sortable: true },
        { key: 'tug_barge', label: 'Tug Barge', sortable: true },
        { key: 'blending_scheme', label: 'Blending Scheme', sortable: true }
      ],
      tableData: []
    }
  },
  computed: {
    ...mapGetters({
      vesselLineUpId: 'VesselLineUp/vesselLineUpId',
      vesselLineUpEndUser: 'VesselLineUp/vesselLineUpEndUser',
      details: 'VesselLineUp/loadingPlanDetail'
    })
  },
  watch: {
    details: {
      immediate: true,
      handler() {
        this.tableData = this.details ? this.details : []
      }
    }
  },
  mounted() {
    this.fetchLoadingPlanDetail()
  },
  methods: {
    fetchLoadingPlanDetail() {
      try {
        this.isLoading = true
        this.$store.dispatch('VesselLineUp/getLoadingPlanDetail', {
          id: this.$route.params.id || this.vesselLineUpId,
          endUser: this.$route.params.endUser || this.vesselLineUpEndUser
        })

        this.isLoading = false
      } catch (e) {
        this.isLoading = false
        this.showFailedNotification(this, 'Failed to fetch loading plan, please try again')
      }
    },
    putOutOrFormatNumber(key, data) {
      if (data && isNumber(data)) {
        switch (key) {
          case 'barge_ton_plan':
          case 'barge_ton_actual':
          case 'cv_adb_plan':
          case 'cv_adb_actual':
          case 'cv_ar_plan':
          case 'cv_ar_actual':
            return this.loRound(data).toLocaleString('id-ID')
          default:
            return this.loRound(data, 2).toLocaleString('id-ID')
        }
      }
      return data || '-'
    },
    sort(sortBy, sortDir) {
      this.isLoading = true
      this.sortBy = sortBy
      this.sortDir = sortDir

      this.tableData = !sortDir
        ? this.transformDataLoadingPlan()
        : sortData(this.transformDataLoadingPlan(), sortBy, sortDir)
      this.isLoading = false
    }
  }
}
</script>

<style lang="scss" scoped>
.button {
  @apply py-4 #{!important};
  @apply rounded-xl;
  @apply border-2;
  @apply font-semibold;
  @apply text-base;
  width: 140px;
  height: calc( 1rem * 10 / 3 );

  &.shadow-secondary {
    -webkit-box-shadow: 0 8px 25px -8px rgba(var(--vs-secondary),1);
    box-shadow: 0 8px 25px -8px rgba(var(--vs-secondary),1);
  }

  &:focus {
    @apply outline-none;
  }
}
</style>
